import { CircularProgress, Typography, withStyles, WithStyles } from '@material-ui/core';
import * as React from 'react';
import colors from '../assets/jss/colors';
import styles from './jss/AppSpinnerStyle';

interface IAppSpinner extends WithStyles<typeof styles> {
  label?: string | null;
}

const AppSpinner: React.FunctionComponent<IAppSpinner> = ({ label, classes }) => (
  <div className={classes.root}>
    <CircularProgress style={{ color: colors.themeColors.warningColor.hex() }} size={28} />
    <Typography variant="body1" className={classes.label}>
      {label}
    </Typography>
  </div>
);

export default withStyles(styles)(AppSpinner);
